import { useContext } from 'react'

import { Box, Chip, Hidden, IconButton, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone'
import { SidebarContext } from 'src/contexts/SidebarContext'
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone'

import Logo from 'src/components/Logo'
import { ConnectButton } from './ConnectButton'
import { useWeb3Context } from 'src/contexts/web3Context'

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 5;
        background-color: ${theme.header.background};
        box-shadow: ${theme.header.boxShadow};
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
)

const Header = (): JSX.Element => {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext)
  const { chainData } = useWeb3Context()

  return (
    <HeaderWrapper display="flex" alignItems="center">
      <Box display="flex" alignItems="center">
        <Hidden lgUp>
          <Logo />
        </Hidden>
        <Hidden lgUp>
          <Tooltip arrow title="Toggle Menu">
            <IconButton color="primary" onClick={toggleSidebar}>
              {!sidebarToggle ? <MenuTwoToneIcon /> : <CloseTwoToneIcon />}
            </IconButton>
          </Tooltip>
        </Hidden>
      </Box>
      <Box display="flex" alignItems="center">
        {chainData?.name && <Chip variant="outlined" label={chainData.name} sx={{ mr: 1 }} />}
        <ConnectButton />
      </Box>
    </HeaderWrapper>
  )
}

export default Header
